<template>
  <article v-if="collections" class="d-flex flex-column mx-xxs-3 mt-0">
    <section class="d-flex flex-row justify-content-between">
      <h5 class="px-xxs-0 text-align-start collection-carousel-title">
        {{ title }}
      </h5>
    </section>
    <div class="ml-minus" style="direction: ltr;">
    <Carousel
      :rtl="$store.getters['tenantConfig/isRTL']"
      :auto-width="true" 
      :margin="4"
      :nav="false"
      :loop="false"
      :rewind="true"
      :items="listCount"
      :dots="false">
    <CollectionsCarouselItem
    v-for="(collection, index) in collections"
    :key="index"
    :item="collection"/>
    </Carousel>
    </div>
  </article>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import CollectionsCarouselItem from '@/components/CollectionsCarouselItem.vue'
import Carousel from '@/components/Carousel.vue'

export default Vue.extend({
  name: 'CollectionsCarouselHost',
  components: {
    Carousel,
    CollectionsCarouselItem
  },
  props:{
    collections: {
      type: Array,
      default: () => {}
    }
  },
  computed: {
    listCount() {
      if (window.innerWidth >= 768){
        return 8
      } else {
        return 3
      }
    }
  },
  data(){
    return {
      title: this.$t('collection.allGenres')
    }
  }
})
</script>
